import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateCompanyDialogComponent } from '../create-company-dialog/create-company-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { map, switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { CompaniesService } from "../../../services/companies.service";
import { Company } from "../../../model/company";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { AuthService } from "../../../services/auth.service";
import { Constants } from "../../../utils/constants";


@Component({
  selector: 'aw-list-companies',
  templateUrl: './list-companies.component.html',
  styleUrls: ['./list-companies.component.scss']
})
export class ListCompaniesComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'companyName',
    'companyEmail',
    'companyAddress',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorCompanies') paginatorUsers!: MatPaginator;
  @Input() company?: Company;
  @Output() makeExpand?: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() embeddedLayout = false;
  dataSource!: MatTableDataSource<Company>;
  expandedCustomers?: Company;
  loggedUser?: any;
  roles = Constants.roles;
  private allCompanies$!: Observable<Company[]>;

  constructor(
    public dialog: MatDialog,
    private companiesService: CompaniesService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

  ngAfterViewInit(): void {
    this.allCompanies$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (!this.company)
              return this.companiesService.getAllCompanies();
            else if (this.loggedUser.role != this.roles.logistic && this.loggedUser.role != this.roles.researcher)
              return this.companiesService.getCompanyById(this.company?.id).pipe(map(value => [value]));
            else
              return of([]);
          }),
          tap(x => {
            this.dataSource = new MatTableDataSource<Company>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allCompanies$.subscribe();
  }

  expandCustomers(element: Company): void {
    this.expandedCustomers != element ?
      this.expandedCustomers = element :
      this.expandedCustomers = undefined;

    if (this.expandedCustomers !== undefined) {
      this.makeExpand?.emit(true);
    }
    else {
      this.makeExpand?.emit(false);
    }

  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortCompanies(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(company: Company): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: company });
  }

  createCompany(): void {
    this.disabled = true;
    this.dialog
      .open(CreateCompanyDialogComponent, { data: { company: new Company() } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allCompanies$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editCompany(company: Company): void {
    this.disabled = false;
    this.dialog
      .open(CreateCompanyDialogComponent, { data: { company: company } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allCompanies$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteCompany(company: Company): void {

    if (company.contracts && company.contracts.length !== 0) {
      this.dialogsService
        .alert("Can't delete company", `This company cannot be deleted since it has contracts in its history`);
    } else {
      this.disabled = true;
      const id = company.id ?? -1;
      this.disabledItemId.push(id);
      this.dialogsService
        .confirm('Delete company', `Are you sure you want to delete the company "${company.companyName}"?`)
        .pipe(
          switchMap((value) => value ?
            this.companiesService.deleteCompany(<number>company.id) :
            EMPTY),
          switchMap(() => this.allCompanies$)
        )
        .subscribe(() => {
          this.disabled = false;
          this.snackService.success('Company deleted!');
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        }, (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        },
          () => {
            this.disabled = false;
            this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
          });
    }

  }

}
